// imports
import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { TEXTS } from '../../constants';

// exports
export default function CookieBanner(): React.ReactElement {
  return (
    <CookieConsent
      overlay
      disableStyles
      expires={400}
      location="bottom"
      buttonText="I Accept"
      cookieName="myCookie"
      containerClasses="cookie-banner"
    >
      {TEXTS.COOKIE_BANNER}
    </CookieConsent>
  );
}
